<template>
  <div class="item-return-reasons">
    <el-select
        :disabled="allChecked"
        :value="selectedReason"
        class="item-return-reason-select"
        placeholder="Select return reason"
        popper-class="item-return-reason-dropdown"
        @change="emitSelected">
      <el-option
          v-for="reason in returnReasons"
          :key="reason.id"
          class="item-return-reason-option"
          :label="reason.text"
          :value="reason.id">
        <span style="float: left">{{ reason.text }}</span>
        <span
            v-if="selectedReason === reason.id && showCheckMark"
            style="float: right !important;"><img
                style="height: 12.28px; width: 15.78px; padding-top: 5px"
                src="../../../../assets/drop-down-checkmark.svg"
                alt="selected"></span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ItemReturnReasons",
  props: {
    selectedReason: {
      type: Number,
      default: null,
    },
    returnReasons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    allSelectedReason: {
      type: String,
      default: "",
    },
    allChecked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCheckMark: false,
    };
  },
  watch: {
    selectedReason: function () {
      this.showCheckMark = this.selectedReason != null;
    },
  },
  mounted() {
    this.showCheckMark = this.selectedReason != null;
  },
  methods: {
    emitSelected(value) {
      this.$emit("selected-reason", value);
    },
  },
};
</script>

<style>
.item-return-reasons {
  display: flex;
  align-self: center;
  width: 320px;
  .el-select {
    display: flex;
    align-items: center;
  }
  .el-input__inner {
    font-family: "Equip", serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #424242 !important;
  }
  .el-select-dropdown el-popper {
    color: #424242;
  }
  .el-select-dropdown__item {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  .el-select-dropdown__list {
    padding: 8px 0;
  }
}
.item-return-reason-option {
  height: 40px !important;
  align-items: center !important;
  padding: 8px 16px !important;
  font-family: "Equip", serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}
.item-return-reason-option:hover {
  background-color: #eff8fc !important;
}
.item-return-reason-select {
  .el-input__inner:focus {
    border: 2px solid #1998d5;
  }
}
.item-return-reason-dropdown {
  padding: 8px 0 !important;
  border: 1px solid #81919f !important;
  .popper__arrow {
    display: none !important;
  }
  .popper__arrow::after {
    display: none !important;
  }
}
.item-return-reason-option.selected {
  color: #1476ad !important;
}
</style>
